import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef
} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-editable-labeled-rich-text',
  templateUrl: './editable-labeled-rich-text.component.html',
  styleUrls: ['./editable-labeled-rich-text.component.scss'],
  standalone: false
})
export class EditableLabeledRichTextComponent implements OnInit {
  public isEditMode: boolean;
  public editForm: UntypedFormGroup;
  private _description: string;
  private _validators: Array<ValidatorFn> = new Array<ValidatorFn>();
  private _validatorsSub: Observable<Array<ValidatorFn>> = of([]);

  get description(): string {
    return this._description;
  }

  @Input()
  fieldName: string = 'field';
  @Input()
  set description(value: string) {
    this._description = value;
    this.toggleEditMode(false);
  }
  @Input()
  label: string;
  @Input()
  set validators(obs: Observable<Array<ValidatorFn>>) {
    this._validatorsSub = obs;
    this._validatorsSub.subscribe((validatorFns) => {
      this._validators = validatorFns;
      this.updateFormValidation();
    });
  }
  get validators(): Observable<Array<ValidatorFn>> {
    return this._validatorsSub;
  }

  @Output()
  save = new EventEmitter<string>();
  @Output()
  isEditModeChange = new EventEmitter<boolean>();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.isEditMode = false;
  }

  onSaveClicked() {
    let newDescription = this.editForm.get('description').value;
    this.save.emit(newDescription);
  }

  isValid(): boolean {
    return this.editForm && this.editForm.valid;
  }

  toggleEditMode(isEditMode: boolean) {
    this.isEditMode = isEditMode;
    if (this.isEditMode) {
      let validators = new Array<ValidatorFn>();
      validators.push(Validators.required);
      validators.push(...this._validators);
      this.editForm = this.formBuilder.group({
        description: [this.description, validators]
      });
    }
    this.isEditModeChange.emit(isEditMode);
  }

  private updateFormValidation() {
    if (!this.isEditMode || !this.editForm) return;

    let descriptionForm = this.editForm.get('description');
    descriptionForm.clearValidators();

    let validators = new Array<ValidatorFn>();
    validators.push(Validators.required);
    validators.push(...this._validators);

    descriptionForm.setValidators(validators);
    descriptionForm.updateValueAndValidity();
  }
}
